import { useFormikContext } from "formik";
import React, { Fragment } from "react";
import Field from "../Field";
import Button from "../Button";
import Loader from "../Loader";

export default function Form({ fields }) {
  const { handleSubmit, isSubmitting, resetForm, errors } = useFormikContext();
  if (!fields) return <p>No form fields</p>;
  if (fields && fields.length < 1) return <p>No form fields</p>;

  if(typeof fields === 'string'){
    fields = JSON.parse(fields)
  }
  const uploadField = fields.filter(word => word.field_type?.includes('file'));
  const Fields = fields.filter(word => {
	if(!word.field_type?.includes('file')) return true
	else{
		return false
	}

});


  return (
    <div>
      <form onSubmit={handleSubmit}>
        {Fields && Fields.map((field, index) => (
          <Fragment key={`fied${index}`}>
            <Field field={field} />
          </Fragment>
        ))}
        {uploadField && uploadField.map((field, index) => (
          <Fragment key={`fied${index}`}>
            <Field field={field} />
          </Fragment>
        ))}
        <div className="form-action">
          
          {/* <Button type="button" onClick={resetForm} className={'clear-form-btn'}>
            Clear Form
          </Button> */}

          <Button type="submit" className="block" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                Submitting...
                <Loader size="small" />
              </>
            ) : (
              "Submit"
            )}
          </Button>
        </div>
      </form>
    </div>
  );
}
